import './HobbiesAndTravellersTypeItem.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getPageThemeColors } from '../../../../utils';
import { hexToRgb } from '../../../../utils/hexToRgb';
const iconCheck = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <g id="Group_17069" data-name="Group 17069" transform="translate(-20 -836.942)">
    <circle id="Ellipse_82" data-name="Ellipse 82" cx="10" cy="10" r="10" transform="translate(20 836.942)" fill="#9c2677"/>
    <g id="Union_56" data-name="Union 56" transform="translate(26.136 843.5)" fill="#fff">
      <path d="M 2.605088710784912 5.968286514282227 L 2.192968130111694 5.556166172027588 L 2.190858125686646 5.554046154022217 L 2.18871808052063 5.551956176757812 L 2.181141376495361 5.544558048248291 L 2.123738050460815 5.486936092376709 L 0.707098126411438 4.070295810699463 L 0.8268673419952393 3.950526714324951 L 2.229198217391968 5.352585792541504 L 2.588978052139282 5.712285995483398 L 2.94238805770874 5.346325874328613 L 7.422352313995361 0.7072658538818359 L 7.545698165893555 0.8265599608421326 L 3.063238143920898 5.494155883789062 L 2.71690821647644 5.854785919189453 L 2.717788696289062 5.855631351470947 L 2.605088710784912 5.968286514282227 Z" stroke="none"/>
      <path d="M 2.605018138885498 6.675315856933594 L 1.769188165664673 5.841145992279053 L 1.770188093185425 5.8404860496521 L -1.883239747257903e-06 4.070295810699463 L 0.8268381357192993 3.243456125259399 L 2.582718133926392 4.998996257781982 L 7.4102783203125 -3.978881977673154e-06 L 8.251438140869141 0.8135260343551636 L 3.423868179321289 5.8404860496521 L 3.432188034057617 5.848475933074951 L 2.605018138885498 6.675315856933594 Z" stroke="none" fill="#fff"/>
    </g>
  </g>
</svg>
`;
const HobbiesAndTravellersTypeItem = _ref => {
  let {
    handleClick,
    id,
    title,
    icon,
    carouselView,
    isActive
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const variables = {
    '--reason-selector-main-01': hexToRgb(selectedPrimaryColor).concat(', 0.1'),
    '--reason-selector-main-05': hexToRgb(selectedPrimaryColor).concat(', 0.5')
  };
  if (!title) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `hobbies-and-travellers-type-card ${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${carouselView ? 'carousel-view' : ''}`,
    style: variables
  }, /*#__PURE__*/React.createElement("input", {
    className: "hobbies-and-travellers-type-checkbox",
    id: `defaultCheck${id}`,
    type: "checkbox",
    checked: isActive,
    tabIndex: 0,
    onKeyPress: event => {
      if (event.key === 'Enter' || event.key === 'NumpadEnter') {
        event.preventDefault();
        handleClick(id);
      }
    },
    onChange: () => {
      handleClick(id);
    }
  }), /*#__PURE__*/React.createElement("label", {
    className: `hobbies-and-travellers-type-checkbox__label ${carouselView ? 'carousel-view' : ''}`,
    htmlFor: `defaultCheck${id}`
  }, isActive && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: iconCheck
    },
    className: "icon-active"
  }), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: icon
    },
    className: "icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, title)));
};
export const commonStyles = "c157iyr2";
export const ltrStyles = "lm7dvoo";
export const rtlStyles = "riby1n0";
export default HobbiesAndTravellersTypeItem;